import * as React from 'react';
import styles from './index.less';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import TopMenuStore from './store';
import BGM from '@src/business-components/bgm';
import Link from '@src/components/link';
// import LanguageSelect from '../common-language-select';
import LanguageSelect from '@src/business-components/common-language-select';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { $$tracker } from '@src/tracker';
import { WORLD_VIEW_LINK } from '@src/constants/business';
import { aLink } from '@src/utils/common-util';
const pageLocalesData = getPageLocalesData();
const lang = getLanguageByPath();

/**
 * 移动端游戏顶部导航
 * 如果需要跳转到具体的节点, 需要在需要跳转的部分, 加入
 * <Element name="menuListId" className="new-classic-appointment-part" />
 * menuListId - 对应的节点id, 匹配menuList中的id值
 * @param store
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */

const TopMenu = ({ store, ...rest }) => {
  store.use();

  /**
   *  典藏礼包
   *  导航栏【礼包中心】开售后状态，下拉展示【特装机典藏版(Amazon US)】和【特装机典藏版(Amazon JP)】2个入口，点击分别跳转至对应的亚* 马逊链接（跳转移动端亚马逊商店对应站点进行购买）
   */

  const giftCenter = () => {
    // if (store.sellStatus === 1) {
    //   return (
    //     <React.Fragment>
    //       <div
    //         className={styles.secondaryMenuItem}
    //         onClick={() => {
    //           store.toLink('');
    //         }}
    //       >
    //         {/* 特式機典藏版(Amazon US) */}
    //         {pageLocalesData.topBar.level2Item9}
    //       </div>
    //       <div
    //         className={styles.secondaryMenuItem}
    //         onClick={() => {
    //           store.toLink('');
    //         }}
    //       >
    //         {/* 特式機典藏版(Amazon JP) */}
    //         {pageLocalesData.topBar.level2Item10}
    //       </div>
    //     </React.Fragment>
    //   );
    // } else {
    return (
      <React.Fragment>
        <div
          className={styles.secondaryMenuItem}
          onClick={() => {
            store.clickGiftPack(pageLocalesData.main.giftPackCopyText);
            $$tracker.clickMainNaviBarCB();
          }}
        >
          {/* 特装机典藏版 */}
          {pageLocalesData.topBar.level2Item8}
        </div>
      </React.Fragment>
    );
    // }
  };

  const infoOut = () => {
    return (
      <div className={cx(styles.infoOutBox, store.menuState ? styles.fadeBigInLeft_active : styles.hide)}>
        <Link
          className={styles.exitBtn}
          onClick={() => {
            store.onExitBtnClick();
          }}
        >
          {pageLocalesData.topBar.logout}
        </Link>
        {/* window.XPASS?.$accountStore?.name */}
        <div className={styles.userName}>{store.login_account}</div>
      </div>
    );
  };
  const logon = () => {
    return (
      <Link
        className={cx(styles.login, store.menuState ? styles.fadeBigInLeft_active : styles.hide)}
        onClick={() => {
          store.loginClick();
          $$tracker.clickMainNaviBarLogin();
        }}
      >
        {pageLocalesData.topBar.loginBtn}
      </Link>
    );
  };

  const account = () => {
    return store.login_status ? infoOut() : logon();
  };

  return (
    <div className={styles.root}>
      <div className={styles.content} data-name="背景">
        <Link className={styles.logo} target="_blank" data-name="ICON" />
        <div className={styles.content_r}>
          <div
            onClick={() => {
              $$tracker.clickMainNaviBarMusic();
            }}
          >
            <BGM store={store.bgm} className={cx(styles.musicBtn)} />
          </div>

          <div className={styles.changeLanguageBtn}>
            <LanguageSelect buttonType={'nav'} displayPosition={'below'} />
            {/* <LanguageSelect store={store.selectStore} buttonType={'nav'} /> */}
          </div>
          <div
            className={styles.menuOpenBtn}
            data-name="下拉选项按钮"
            onClick={() => {
              store.onchangeMenu(true);
            }}
          />
        </div>
      </div>

      {/* 下拉导航 */}
      <div ref={store.menuRef} className={cx(styles.menuContent, store.menuState ? styles.menuAct : '')} data-name="下拉导航">
        <div
          className={cx(store.menuState ? styles.menuClose : styles.menuList)}
          onClick={() => {
            store.onchangeMenu(false);
          }}
        />
        {account()}
        {/* 二级菜单- */}
        <div
          className={cx(styles.menuItem, store.menuState ? styles.fadeBigInRight_active1 : styles.hide)}
          onClick={() => {
            store.toIndex(0);
            $$tracker.clickMainNaviBarHome();
          }}
        >
          <Link className={cx(styles.menuItemBtn)}>{pageLocalesData.topBar.item1}</Link>
        </div>
        <div
          className={cx(styles.menuItem, store.menuState ? styles.fadeBigInRight_active2 : styles.hide)}
          onClick={() => {
            store.toIndex(1);
            $$tracker.clickMainNaviBarNews();
          }}
        >
          <Link className={cx(styles.menuItemBtn)}>{pageLocalesData.topBar.item2}</Link>
        </div>
        {/* 游戏介绍 */}
        <div
          className={cx(styles.menuItem, store.secondaryMenuState1 && styles.menuItemActive, store.menuState ? styles.fadeBigInRight_active3 : styles.hide)}
          onClick={() => {
            store.openSecondaryMenu('游戏介绍', 1);
          }}
        >
          <Link className={cx(styles.menuItemBtn, store.secondaryMenuState1 && styles.menuItemBtnActive)}>
            {/* 游戏介绍 */}
            {pageLocalesData.topBar.item3}
          </Link>
          <span className={cx(styles.secondaryMenuIcon, store.secondaryMenuState1 && styles.secondaryMenuIconActive)} />
          {store.secondaryMenuState1 && (
            <React.Fragment>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toRouter('game-play');
                  $$tracker.clickMainNaviBarCombat();
                }}
              >
                {/* 游戏玩法 */}
                {pageLocalesData.topBar.level2Item1}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toIndex(2);
                  $$tracker.clickMainNaviBarStrikers();
                }}
              >
                {/* 机兵介绍 */}
                {pageLocalesData.topBar.level2Item2}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toRouter('mecha-unit-list');
                  $$tracker.clickMainNaviBarCustom();
                }}
              >
                {/* 王牌档案*/}
                {pageLocalesData.topBar.level2Item15}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toRouter('map');
                  $$tracker.clickMainNaviBar6v6maps();
                }}
              >
                {/* 地图资料-6v6 */}
                {pageLocalesData.topBar.level2Item3}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toRouter('map-wpxl');
                  $$tracker.clickMainNaviBar3v3maps();
                }}
              >
                {/* 地图资料-3v3 */}
                {pageLocalesData.topBar.level2Item14}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={e => {
                  store.openthirdMenuMenu(e, '风暴计划', 1);
                  $$tracker.clickMainNaviBarstorm();
                }}
              >
                <span className={styles.thirdMenuName}>{pageLocalesData.topBar.level3Item11}</span>
                <span className={cx(styles.thirdMenuMenuIcon, store.thirdMenuState2_Item && styles.thirdMenuIconActive)} />
                {store.thirdMenuState2_Item && (
                  <React.Fragment>
                    <div
                      className={styles.thirdMenuItem}
                      onClick={e => {
                        e.stopPropagation();
                        $$tracker.clickMainNaviBarStormSashmak();
                        store.toLink(`https://mechabreak.seasungames.com/zt/m/msmk/${lang}/index.html#/`);
                      }}
                    >
                      {pageLocalesData.topBar.level2Item12}
                    </div>
                    {/* <div
                      className={styles.thirdMenuItem}
                      onClick={e => {
                        e.stopPropagation();
                        Toast.info(pageLocalesData.global.comming_soon);
                      }}
                    >
                      {pageLocalesData.global.comming_soon}
                    </div> */}
                  </React.Fragment>
                )}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toRouter('wallpaper');
                  $$tracker.clickMainNaviBarWallpaper();
                }}
              >
                {/* 壁纸*/}
                {pageLocalesData.topBar.level2Item16}
              </div>

              {/* <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(`https://mechabreak.seasungames.com/p/m/2024/12/19/dlc/${lang}/index.html#/`);
                }}
              > */}
              {/* 玛什玛克攻略站 */}
              {/* {pageLocalesData.topBar.level2Item12}
              </div> */}
            </React.Fragment>
          )}
        </div>
        {/* 世界观 */}
        <div
          className={cx(styles.menuItem, store.menuState ? styles.fadeBigInRight_active4 : styles.hide)}
          onClick={() => {
            aLink(WORLD_VIEW_LINK);
            $$tracker.clickMainNaviBarWorld();
          }}
        >
          {pageLocalesData.topBar.level2Item4}
        </div>
        {/* FAQ */}
        {/* <div
          className={cx(styles.menuItem, store.secondaryMenuState2 && styles.menuItemActive, store.menuState ? styles.fadeBigInRight_active4 : styles.hide)}
          onClick={() => {
            store.openSecondaryMenu('FAQ', 2);
          }}
        >
          <Link className={cx(styles.menuItemBtn, store.secondaryMenuState2 && styles.menuItemBtnActive)}>
             FAQ
            {pageLocalesData.topBar.item7}
          </Link>
          <span className={cx(styles.secondaryMenuIcon, store.secondaryMenuState2 && styles.secondaryMenuIconActive)} />
          {store.secondaryMenuState2 && (
            <React.Fragment>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(store.FAQUrl[lang]);
                }}
              >
                客服中心 
                {pageLocalesData.topBar.level2Item13}
              </div>
            </React.Fragment>
          )}
        </div> */}
        {/* 活动专区 */}

        <div
          className={cx(styles.menuItem, store.secondaryMenuState4 && styles.menuItemActive, store.menuState ? styles.fadeBigInRight_active6 : styles.hide)}
          onClick={() => {
            store.openSecondaryMenu('活动专区', 4);
          }}
        >
          <Link className={cx(styles.menuItemBtn, store.secondaryMenuState4 && styles.menuItemBtnActive)}>
            {/* 活动专区 */}
            {pageLocalesData.topBar.item4}
          </Link>
          <span className={cx(styles.secondaryMenuIcon, store.secondaryMenuState4 && styles.secondaryMenuIconActive)} />
          {store.secondaryMenuState4 && (
            <React.Fragment>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(store.FAQUrl[lang]);
                  $$tracker.clickMainNaviBarSC();
                }}
              >
                {/* 客服中心 */}
                {pageLocalesData.topBar.level2Item13}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(store.zxph[lang]);
                  $$tracker.clickMainNaviBarSR();
                }}
              >
                {/* 造型排行榜 */}
                {pageLocalesData.topBar.level2Item11}
              </div>
              {/* <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(store.CZZUrl[lang]);
                  $$tracker.clickMainNaviBarPT();
                }}
              > */}
              {/* 先驱小队活动 */}
              {/* {pageLocalesData.topBar.level2Item7}
              </div> */}
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(`https://mechabreak.seasungames.com/p/m/2024/07/25/twitch-drop/${lang}/index.html#/`);
                  $$tracker.clickMainNaviBarTD();
                }}
              >
                {/* Twitch Drops */}
                {pageLocalesData.topBar.level2Item6}
              </div>
              <div
                className={styles.secondaryMenuItem}
                onClick={() => {
                  store.toLink(`https://mechabreak.seasungames.com/creator_program/m/${lang}/`);
                  $$tracker.clickMainNaviBarCR();
                }}
              >
                {/* 创作者活动 */}
                {pageLocalesData.topBar.level2Item5}
              </div>
            </React.Fragment>
          )}
        </div>
        {/* 礼包中心 */}
        <div
          className={cx(styles.menuItem, store.secondaryMenuState5 && styles.menuItemActive, store.menuState ? styles.fadeBigInRight_active7 : styles.hide)}
          onClick={() => {
            store.openSecondaryMenu('礼包直购', 5);
          }}
        >
          <Link className={cx(styles.menuItemBtn, store.secondaryMenuState5 && styles.menuItemBtnActive)}>
            {/* 礼包直购 */}
            {pageLocalesData.topBar.item5}
          </Link>
          <span className={cx(styles.secondaryMenuIcon, store.secondaryMenuState5 && styles.secondaryMenuIconActive)} />
          {store.secondaryMenuState5 && giftCenter()}
        </div>
        {/* 关注我们 */}
        <div
          className={cx(styles.menuItem, store.secondaryMenuState6 && styles.menuItemActive, store.menuState ? styles.fadeBigInRight_active8 : styles.hide)}
          onClick={() => {
            store.openSecondaryMenu('关注我们', 6);
          }}
        >
          <Link className={cx(styles.menuItemBtn, store.secondaryMenuState6 && styles.menuItemBtnActive)}>
            {/* 关注我们 */}
            {pageLocalesData.topBar.item6}
          </Link>
          <span className={cx(styles.secondaryMenuIcon, store.secondaryMenuState6 && styles.secondaryMenuIconActive)} />
          {store.secondaryMenuState6 && (
            <React.Fragment>
              <div className={styles.usBox}>
                {store.itemList.map((item, key) => {
                  return (
                    <div
                      className={styles.listItem}
                      key={key}
                      onClick={() => {
                        store.onRedirectLink(item.link);
                        item.onClick();
                      }}
                    >
                      {/* <div className={styles.itemImg}> */}
                      <img src={item.img} alt={''} />
                      {/* </div> */}
                      {/* <div className={styles.itemName}>{item.name}</div> */}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          )}
        </div>
        {/* logo  */}
        <div className={cx(styles.logBox, store.menuState ? styles.fadeInDown_active : styles.hide_down)}>
          <Link className={styles.xsjLogo} href="https://www.seasungames.com/m/index.html#/" target={'_blank'} />
          <div className={styles.logo_line} />
          <div
            className={styles.mechaLogo}
            onClick={() => {
              store.toLink(`https://mechabreak.seasungames.com/m/${lang}/index.html#/`);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(TopMenu, TopMenuStore);
